module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/room-9d6032dabb31bc11068d450eafd86567.webp";